import React, { useState, useEffect } from "react";
import "./dashboard.css";
import Sidebar from "./Sidebar/Sidebar";
import ShareFeedback from "./Sidebar/Modals/share-feedback";
import Feedback from "./Sidebar/Modals/feedback";
import { useQuery } from "@tanstack/react-query";
import { getUserEnrollmentStatusService } from "../../services/programs.service";

const Sidbar = () => {

  const [isOpen, setIsOpen] = useState(null);
  const [user, setUser] = useState("");
  const [enrol_id, setEnrol_id] = useState("");
  const [category, setCategory] = useState("");
  const [term, setTerm] = useState("");

  const status = localStorage.getItem("status");
  const user_id = localStorage.getItem("user_id");
  const category_id = localStorage.getItem("category");
  const isStatusValid = status && status !== "undefined" && status !== "null";
  const batch_id = localStorage.getItem("batch_id");
  const program_id = localStorage.getItem("program_id");


  const { data: statusData } = useQuery({
    queryFn: () =>
      getUserEnrollmentStatusService({
        user_id,
        category_id,
        program_id,
        batch_id,
      }),
    queryKey: ["enrollmentStatus", user_id, category_id, program_id, batch_id],
    enabled: !isStatusValid, // Run only if status is not valid
  });

  if (statusData) {
    const status = statusData?.data[0]?.status;
    if (status) {
      localStorage.setItem("status", status);
    } else {
      localStorage.setItem("status", "revoked");
    }
  }

  useEffect(() => {

    var user_id = localStorage.getItem("user_id");
    var enrol_id = localStorage.getItem("enrol_id");
    var category = localStorage.getItem("category");
    var term = localStorage.getItem("term");
    setTerm(term);
    setUser(user_id);
    setEnrol_id(enrol_id);
    setCategory(category);

  }, []);

  return (
    <>
      <Sidebar setOpen={setIsOpen} />
      <Feedback open={isOpen} setOpen={setIsOpen} />
      <ShareFeedback open={isOpen} setOpen={setIsOpen} />
    </>
  );
};
export default Sidbar;